// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ryStWlJzTdtvnrWtkrXH {\n\tdisplay: flex;\n\talign-items: center;\n\talign-self: stretch;\n\tjustify-content: center;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/ErrorPage.module.scss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,uBAAuB;AACxB","sourcesContent":[".page {\n\tdisplay: flex;\n\talign-items: center;\n\talign-self: stretch;\n\tjustify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "ryStWlJzTdtvnrWtkrXH"
};
export default ___CSS_LOADER_EXPORT___;
